export const CATERING_PATH = 'https://www.ezcater.com/brand/pvt/firehouse-subs';
export const FOUNDATION_PATH = 'https://firehousesubsfoundation.org/';
export const CAREERS_PATH = 'https://careers.firehousesubs.com';
